import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
const AboutHome = lazy(() => import("Components/About/AboutHome"));
const PSEFilings = lazy(() => import("Components/About/PSEFilings"));
const ListiclePage = lazy(() => import("Components/ListiclePage"));
const Newsroom = lazy(() => import("Components/About/Newsroom"));
const boardofdirectors = lazy(() =>
  import("Components/About/boardofdirectors")
);
const Career = lazy(() => import("Components/About/Career"));
const CorporateGovernance = lazy(() =>
  import("Components/About/CorporateGovernance")
);
const corporategovernanceinner = lazy(() =>
  import("Components/About/corporategovernanceinner")
);
const InvestorRelations = lazy(() =>
  import("Components/About/InvestorRelations")
);
const NewsroomInner = lazy(() => import("Components/About/NewsroomInner"));
const ShareholdingStructure = lazy(() =>
  import("Components/About/ShareholdingStructure")
);
const ListicleExpansion = lazy(() => import("Components/ListicleExpansion"));
const WhoWeAre = lazy(() => import("Components/About/WhoWeAre"));
// const SecFilling = lazy(() => import("Components/SecFilling"));

const SecFilling = lazy(() => import("pages/SecFiling"));

const ManatalCareers = lazy(() => import("Components/About/Career"));

const AboutRoutes = () => {
  return (
    <Switch>
      <Route
        path={`/about/whoweare/boardofdirectors`}
        component={boardofdirectors}
      />
      <Route
        path="/about/corporategovernance/:id"
        component={corporategovernanceinner}
      />
      <Route
        path="/about/corporategovernance"
        component={CorporateGovernance}
      />
      <Route
        path="/about/investorrelations/publishedstatementofcondition"
        component={ListicleExpansion}
      />
      <Route
        path="/about/investorrelations/psefilings"
        component={PSEFilings}
      />
      <Route
        path="/about/investorrelations/secfilings"
        component={SecFilling}
      />
      <Route path="/about/investorrelations/:id" component={ListiclePage} />
      <Route path="/about/investorrelations" component={InvestorRelations} />
      <Route path="/about/careers" component={ManatalCareers} />
      <Route path="/about/newsroom/:id" component={NewsroomInner} />
      <Route path="/about/newsroom" component={Newsroom} />
      <Route
        path="/about/whoweare/shareholdingstructure"
        component={ShareholdingStructure}
      />
      <Route path="/about/whoweare" component={WhoWeAre} />
      <Route exact path="/about" component={AboutHome} />
      <Route path="*" component={() => <Redirect to="/about" />} />
    </Switch>
  );
};

export default AboutRoutes;
